module.exports = __webpack_public_path__ + "static/media/Navprostets.973f3642.mp3";